import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';

// Inbox plus is enabled in the UI when the user configuration InboxPlusTabs property is set. We
// need this to be set on the server so we guarantee the correct items are being sent in sessiondata
export function isInboxPlusEnabled(): boolean {
    return isInAnyInboxPlusTreatment() && getUserConfiguration().UserOptions.InboxPlusTabs !== null;
}

export function isInAnyInboxPlusExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusDefaultTabs') ||
        isFeatureEnabled('tri-inboxPlusDefaultTabsControl') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusion') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusionControl') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedInclusion') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedInclusionControl')
    );
}

// The user will see Inbox Plus UI if any of these flags are enabled
export function isInAnyInboxPlusTreatment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusDefaultTabs') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusion') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedInclusion')
    );
}

export function isInEasyOnFocusedExclusionExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusion') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedExclusionControl')
    );
}

export function isInEasyOnFocusedInclusionExperiment(): boolean {
    return (
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedInclusion') ||
        isFeatureEnabled('tri-inboxPlusEasyOnFocusedInclusionControl')
    );
}
